import React, { Component } from 'react'
import { Grid, Button, ButtonGroup, styled } from '@material-ui/core'
import Checkbox from '../../CheckBox'
import { t as i18n } from 'ttag'

const MyGrid = styled(Grid)({
  marginBottom: 40
})

const risks = [
  'All',
  'Adverse Media',
  'Sanction List',
  'Politically Exposed Person / Government Officials',
  'State Owned Entities',
  'Custom List',
  'Watchlists and Blacklists'
]

class checkContainer extends Component {
  state = {
    checkboxes: risks.reduce(
      (options, option) => ({
        ...options,
        [option]: false
      }),
      {}
    )
  }

  selectAllCheckboxes = isSelected => {
    Object.keys(this.state.checkboxes).forEach(checkbox => {
      this.setState(prevState => ({
        checkboxes: {
          ...prevState.checkboxes,
          [checkbox]: isSelected
        }
      }))
    })
  }

  selectAll = () => this.selectAllCheckboxes(true)

  deselectAll = () => this.selectAllCheckboxes(false)

  handleCheckboxChange = changeEvent => {
    const { name } = changeEvent.target

    this.setState(prevState => ({
      checkboxes: {
        ...prevState.checkboxes,
        [name]: !prevState.checkboxes[name]
      }
    }))
  }

  handleFormSubmit = formSubmitEvent => {
    formSubmitEvent.preventDefault()

    Object.keys(this.state.checkboxes)
      .filter(checkbox => this.state.checkboxes[checkbox])
      .forEach(checkbox => {
        console.log(checkbox, 'is selected.')
      })
  }

  createCheckbox = option => (
    <Checkbox
      label={option}
      isSelected={this.state.checkboxes[option]}
      onCheckboxChange={this.handleCheckboxChange}
      key={option}
    />
  )

  createCheckboxes = () => risks.map(this.createCheckbox)

  render() {
    return (
      <div>
        <form onSubmit={this.handleFormSubmit}>
          <MyGrid container>{this.createCheckboxes()}</MyGrid>
          <ButtonGroup size='medium'>
            <Button variant='outlined' onClick={this.selectAll}>
              {i18n`Select All`}
            </Button>
            <Button variant='outlined' onClick={this.deselectAll}>
              {i18n`Deselect All`}
            </Button>
            <Button variant='contained' color='primary' type='submit'>
              {i18n`Save`}
            </Button>
          </ButtonGroup>
        </form>
      </div>
    )
  }
}

export default checkContainer
